import { tsIoValidate } from "../../../../utils/general/generalUtils"
import { IDnoData, DnoData } from "../../types/dnoInterface/dnoHomepageTypes"

export const dnoHomepageMapper = {
    /**
     * Maps the response from the DNO Homepage API to the IDnoData interface.
     * @param response - The response from the API.
     * @returns The mapped object of type IDnoData.
     */
    mapDnoData: (response: unknown): IDnoData => {
        const res = tsIoValidate<IDnoData>(
            DnoData,
            response,
            "Error mapping DNO data."
        )
        return res
    },
}
